// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"d86c974c","326":"6f4b4646","624":"01bfa4c8"}[chunkId] + ".css";
};